import { useState } from "react";
import { Gift, X, ArrowRight } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../context/SiteContext";
import { fileUrl } from "../../lib/api";

export const PromoBanner = ({ onJoin }) => {
  const { promo: t } = useLang().t;
  const { site } = useSite();
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;
  return (
    <section className="relative z-10 mx-auto -mt-10 max-w-7xl px-4 sm:px-6 lg:px-8" data-testid="promo-banner">
      <div className="promo-shine relative overflow-hidden rounded-2xl border border-[#F3D77A]/60 bg-gradient-to-r from-[#9A7B2C] via-[#D4AF37] to-[#B8922E] p-[1px] shadow-[0_0_40px_rgba(212,175,55,0.35)]">
        <div className="relative flex flex-col gap-6 overflow-hidden rounded-2xl bg-gradient-to-r from-[#D4AF37] via-[#E9C965] to-[#C29B32] px-6 py-7 text-black md:flex-row md:items-center md:justify-between md:px-10">
          {t.image && <img src={fileUrl(t.image, site?.performance?.cdn_base_url)} alt="" aria-hidden className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-25 mix-blend-multiply" data-testid="promo-image" />}
          <button onClick={() => setHidden(true)} data-testid="promo-close" aria-label="Close" className="absolute right-3 top-3 rounded-full p-1 text-black/60 transition-colors hover:bg-black/10 hover:text-black">
            <X size={16} />
          </button>
          <div className="flex items-center gap-5">
            <div className="grid h-14 w-14 shrink-0 place-items-center rounded-full border-2 border-black/80 bg-black text-[#D4AF37]">
              <Gift size={24} />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-black/70">{t.eyebrow}</p>
              <h2 className="mt-1 font-serif text-2xl font-extrabold uppercase sm:text-3xl" data-testid="promo-title">{t.title}</h2>
              <p className="mt-1 text-sm text-black/75">{t.sub}</p>
            </div>
          </div>
          <button onClick={onJoin} data-testid="promo-claim-button"
            className="group inline-flex w-fit shrink-0 items-center gap-2 rounded-full bg-black px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] text-[#F3D77A] transition-transform hover:-translate-y-0.5">
            {t.cta} <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
      <p className="mt-2 text-right text-[11px] text-zinc-600">{t.terms}</p>
    </section>
  );
};
